import { render, staticRenderFns } from "./detail_dingdan.vue?vue&type=template&id=442bb820&scoped=true"
import script from "./detail_dingdan.vue?vue&type=script&lang=js"
export * from "./detail_dingdan.vue?vue&type=script&lang=js"
import style0 from "./detail_dingdan.vue?vue&type=style&index=0&id=442bb820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442bb820",
  null
  
)

export default component.exports